const { createContext } = require("react");

export const AlertaContext = createContext();
